var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "a-tabs",
        {
          attrs: {
            "default-active-key": "1",
            size: "large",
            "tab-bar-style": { marginBottom: "24px", paddingLeft: "16px" }
          },
          on: { change: _vm.changeTabs }
        },
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { loading: "true", tab: _vm.tabName1 } },
            [
              _c(
                "j-form-container",
                [
                  _c(
                    "a-form-model",
                    {
                      ref: "form",
                      attrs: {
                        slot: "detail",
                        model: _vm.model,
                        rules: _vm.validatorRules
                      },
                      slot: "detail"
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.applicationCode"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "max-Length": "64",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.applicationCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationCode", $$v)
                              },
                              expression: "model.applicationCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.applicationName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationName"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              "max-Length": "64",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.applicationName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationName", $$v)
                              },
                              expression: "model.applicationName"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary", disabled: false },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "SysBmApplication",
                                    "applicationName",
                                    _vm.applicationNameLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.applicationDesc"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationDesc"
                          }
                        },
                        [
                          _c("a-textarea", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              maxLength: 255,
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.applicationDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationDesc", $$v)
                              },
                              expression: "model.applicationDesc"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "SysBmApplication",
                                    "applicationDesc",
                                    _vm.applicationDescLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["portal.ui2.appMajorFunction"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "functionDesc"
                          }
                        },
                        [
                          _c("a-textarea", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              placeholder: this.language[
                                "portal.ui2.appMajorFunction.desc"
                              ],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.functionDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "functionDesc", $$v)
                              },
                              expression: "model.functionDesc"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["application.realm"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "orgIds"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                allowClear: "",
                                mode: "multiple",
                                placeholder: this.language[
                                  "application.realm.desc"
                                ]
                              },
                              on: { change: _vm.updateOrg },
                              model: {
                                value: _vm.model.orgIds,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "orgIds", $$v)
                                },
                                expression: "model.orgIds"
                              }
                            },
                            _vm._l(_vm.orgList, function(org, index) {
                              return _c(
                                "a-select-option",
                                {
                                  key: index.toString(),
                                  attrs: { value: org.id }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(org.portalOrgName) +
                                      "\n                  "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["portal.ui2.appContacts"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contactUser"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "max-Length": "64",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.contactUser,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contactUser", $$v)
                              },
                              expression: "model.contactUser"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["portal.ui2.appContactInfo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contactMode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "max-Length": "64",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.contactMode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contactMode", $$v)
                              },
                              expression: "model.contactMode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["application.informationWindow"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "informationWindow"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "max-Length": "50",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.informationWindow,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "informationWindow", $$v)
                              },
                              expression: "model.informationWindow"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["application.applicationStatus"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationStatus"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "application_status",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.applicationStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationStatus", $$v)
                              },
                              expression: "model.applicationStatus"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.applicationType"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationType"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              allowClear: true,
                              dictCode: "application_type",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.applicationType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationType", $$v)
                              },
                              expression: "model.applicationType"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.opentype"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "openType"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "open_type",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.openType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "openType", $$v)
                              },
                              expression: "model.openType"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.thirdFlag"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "thirdFlag"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "third_flag",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.thirdFlag,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "thirdFlag", $$v)
                              },
                              expression: "model.thirdFlag"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["portal.third.party.review"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "thirdCheck"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "third_flag",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.thirdCheck,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "thirdCheck", $$v)
                              },
                              expression: "model.thirdCheck"
                            }
                          })
                        ],
                        1
                      ),
                      !this.thridCheckUrldisable
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language["portal.third.party.review"] +
                                  "Url",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  "max-Length": "64",
                                  disabled: _vm.thridCheckUrldisable
                                },
                                model: {
                                  value: _vm.model.thirdCheckUrl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "thirdCheckUrl", $$v)
                                  },
                                  expression: "model.thirdCheckUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.ssoFlag"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "ssoFlag"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "sso_flag",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.ssoFlag,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "ssoFlag", $$v)
                              },
                              expression: "model.ssoFlag"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["application.applicationImgPath"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": _vm.uploadSource,
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.applicationImgPath,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationImgPath", $$v)
                              },
                              expression: "model.applicationImgPath"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.applicationUrl"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "max-Length": "255",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.applicationUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationUrl", $$v)
                              },
                              expression: "model.applicationUrl"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language[
                                "application.applicationInternalUrl"
                              ],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "max-Length": "255",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.applicationInternalUrl,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "applicationInternalUrl",
                                  $$v
                                )
                              },
                              expression: "model.applicationInternalUrl"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.h5Url"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "max-Length": "255",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.h5Url,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "h5Url", $$v)
                              },
                              expression: "model.h5Url"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["application.management.unit"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "managementUnit"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.formDisabled },
                            model: {
                              value: _vm.model.managementUnit,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "managementUnit", $$v)
                              },
                              expression: "model.managementUnit"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["basedata.remark"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["basedata.remark"],
                              maxLength: 500,
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "application:extinfo",
                              expression: "'application:extinfo'"
                            }
                          ],
                          attrs: {
                            label: _vm.language["system.permission.extInfo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "extInfo"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["system.permission.extInfo"],
                              maxLength: 1000,
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.extInfo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "extInfo", $$v)
                              },
                              expression: "model.extInfo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-tab-pane",
            {
              key: "2",
              attrs: { loading: "true", tab: _vm.tabName2, forceRender: "true" }
            },
            [
              _c(
                "j-form-container",
                [
                  _c(
                    "a-form-model",
                    {
                      ref: "form",
                      attrs: {
                        slot: "detail",
                        model: _vm.details,
                        rules: _vm.validatorRules
                      },
                      slot: "detail"
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-checkbox-group",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "left"
                                  },
                                  attrs: { disabled: _vm.formDisabled },
                                  on: { change: _vm.languageSettingsChange },
                                  model: {
                                    value: _vm.languageSettings,
                                    callback: function($$v) {
                                      _vm.languageSettings = $$v
                                    },
                                    expression: "languageSettings"
                                  }
                                },
                                [
                                  _c(
                                    "a-row",
                                    { attrs: { gutter: 24 } },
                                    _vm._l(_vm.allLanguageTemplate, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "a-col",
                                        {
                                          key: index,
                                          staticStyle: {
                                            "padding-bottom": "12px"
                                          },
                                          attrs: { span: 8 }
                                        },
                                        [
                                          _c(
                                            "a-checkbox",
                                            { attrs: { value: item.value } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.language[item.langKey]
                                                ) + " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("j-editable-table", {
                                ref: "sortTable",
                                attrs: {
                                  rowNumber: "",
                                  dragSort: "",
                                  columns: _vm.columns,
                                  dataSource: _vm.dataSource,
                                  sortInsertDown: false
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-tab-pane",
            {
              key: "3",
              attrs: { loading: "true", tab: _vm.tabName3, forceRender: "true" }
            },
            [
              _c(
                "j-form-container",
                [
                  _c(
                    "a-form-model",
                    {
                      ref: "form",
                      attrs: {
                        slot: "detail",
                        model: _vm.details,
                        rules: _vm.validatorRules
                      },
                      slot: "detail"
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["application.isRegisterApplication"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: ""
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "register_flag",
                              disabled: _vm.formDisabled
                            },
                            on: { change: _vm.registerChange },
                            model: {
                              value: _vm.details.isRegisterApplication,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.details,
                                  "isRegisterApplication",
                                  $$v
                                )
                              },
                              expression: "details.isRegisterApplication"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.details.isRegisterApplication == "1"
                        ? _c(
                            "div",
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.language[
                                        "application.applicationKey"
                                      ],
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "applicationKey"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      "max-Length": "60",
                                      disabled: _vm.formDisabled
                                    },
                                    model: {
                                      value: _vm.details.applicationKey,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.details,
                                          "applicationKey",
                                          $$v
                                        )
                                      },
                                      expression: "details.applicationKey"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.language[
                                        "application.applicationSecret"
                                      ],
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "applicationSecret"
                                  }
                                },
                                [
                                  _c(
                                    "a-row",
                                    { attrs: { type: "flex", gutter: 8 } },
                                    [
                                      _c(
                                        "a-col",
                                        { staticClass: "left" },
                                        [
                                          _c("a-input", {
                                            staticStyle: {
                                              "background-color": "whitesmoke"
                                            },
                                            attrs: {
                                              "max-Length": "64",
                                              readOnly: ""
                                            },
                                            model: {
                                              value:
                                                _vm.details.applicationSecret,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.details,
                                                  "applicationSecret",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "details.applicationSecret"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { staticClass: "right" },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                disabled: _vm.formDisabled
                                              },
                                              on: { click: _vm.refreshData }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.language["common.refresh"]
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: _vm.language["application.urls"],
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: ""
                                  }
                                },
                                [
                                  _c("a-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "max-Length": "2000",
                                      disabled: _vm.formDisabled
                                    },
                                    model: {
                                      value: _vm.details.urls,
                                      callback: function($$v) {
                                        _vm.$set(_vm.details, "urls", $$v)
                                      },
                                      expression: "details.urls"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("language-model", { ref: "languageModel", on: { ok: _vm.languageOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }